$(document).ready(function () {
    $('[data-store-elements-block]').each(function(index){
        let elt = $(this);
        let contentGuid = elt.attr("data-block-guid");
        let parentTabPane = elt.closest('.tab-pane');

        // On page load fetch directly if no tab is used or it is the active one
        if(     parentTabPane.length === 0 // no tab 
            ||  parentTabPane.hasClass('active') === true) // active tab
        {
            handleHydration();
        }
        else
        {
            // post-poned hydratation when parent tab gets active once
            const config = { attributes: true, attributeOldValue: true, attributeFilter: ['class'] };
            const observer = new MutationObserver(handleParentTabPaneMutation);
            observer.observe(parentTabPane.get(0), config);
        }

        // Fetch the block html content by GET call
        function handleHydration()
        {
            $.ajax({
                url: "/DefaultPage/ContentRendering",
                type: "GET",
                data : {contentGuid : contentGuid},
                success: function (response) {
                    elt.html(response);
                },
                error: function (response) {
                    console.log("ajax request failed for store element block");
                }
            });
        }

        // When the parent tab gets active once
        function handleParentTabPaneMutation(mutationsList, observer) {
            for(let mutation of mutationsList) {
                if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                    // Check if the 'active' class was added
                    const targetElement = mutation.target;
                    const isAdded = targetElement.classList.contains('active') && !mutation.oldValue.includes('active');
                    // Trigger your desired action
                    if (isAdded) {
                        handleHydration();
                        observer.disconnect();
                        break;
                    }
                }
            }
        }
    });
});
